<template lang="html">
    <div class="sumoning" ref="sumoning">
      <List v-if="sumoning.length" v-model="loading" :finished="finished" @onload="getSumoning">
        <div class="content">
            <SummoningOrderItem  v-for="item of sumoning" :key="item.id" v-bind="item" />
        </div>
      </List>
      <div v-else class="empty">
          <span>当前还没有召集中的活动发一个试试？</span>
          <button @click="goCreate">去发布</button>
      </div>
      <div class="analyse_icon" @click="goCreate">
          <img src="../../../assets/images/tabs/plus-new.svg">
      </div>
      <!-- <div class='publishSummoningOrder'>
          <img src='../../../assets/images/tabs/plus-new.svg'>
          <div class='text'>发布</div>
      </div> -->
    </div>
</template>
<script>
import { isAndroid } from '../../../utils/utils'
import { get } from '../../../utils/request'
import { set, remove, get as getUser } from '../../../utils/token'
import SummoningOrderItem from '../../../components/SummoningOrderItem'
import { createNamespacedHelpers } from 'vuex'
import List from '../../../components/list'
const { mapActions } = createNamespacedHelpers('message')
export default {
  components: {
    SummoningOrderItem,
    List
  },
  data () {
    return {
      isAndroid: isAndroid(),
      safeHeight: 0,
      sumoning: [],
      loading: false,
      finished: false,
      touchStart: 0,
      page: 1,
      size: 10,
      count: 0
    }
  },
  // activated () {
  //   this.page = 1
  //   this.count = 0
  //   this.sumoning.length = 0
  //   this.getSumoning()
  // },
  mounted () {
    this.pageInit()
  },
  methods: {
    pageInit () {
      this.page = 1
      this.count = 0
      this.sumoning.length = 0
      this.getSumoning()
      this.addUpRefresh()
    },
    ...mapActions({
      updateTaleCount: 'updateTaleCount'
    }),
    updateItem (item, reload) {
      Object.assign(item, reload)
    },
    deleteMessage (id) {
      let index = 0
      this.sumoningsumoning.forEach((item, _index) => {
        if (Object.is(id, item.id)) {
          index = _index
        }
      })
      this.sumoning.splice(index, 1)
    },
    resetPagination () {
      this.downLabel = ''
      this.touchStart = 0
      this.distance = 0
    },
    addUpRefresh () {
      const el = this.$refs.sumoning
      const offsetHeight = el.offsetHeight
      el.addEventListener('scroll', () => {
        if (this.loading) {
          return
        }
        const scrollHeight = el.scrollHeight
        const scrollTop = el.scrollTop
        if (offsetHeight + scrollTop >= scrollHeight) {
          const { count, sumoning, page } = this
          if (count > sumoning.length) {
            this.loading = true
            this.page = page + 1
            this.getSumoning()
          }
        }
      })
    },
    addDownRefresh () {
      const el = this.$refs.sumoning
      el.addEventListener('touchstart', e => {
        if (this.downRefresh) {
          e.preventDefault()
          return
        }
        this.touchStart = e.targetTouches[0].clientY
      })
      el.addEventListener('touchmove', e => {
        if (this.downRefresh) {
          e.preventDefault()
          return
        }
        if (el.scrollTop === 0) {
          const touch = e.targetTouches[0]
          const distance = touch.clientY - this.touchStart
          this.distance = distance
          if (distance > 50) {
            this.downRefresh = true
            this.downLabel = '松手刷新数据'
          }
        }
      })
      el.addEventListener('touchend', e => {
        if (this.distance > 50) {
          this.downRefresh = true
          this.downLabel = '正在刷新'
          e.preventDefault()
          this.page = 1
          this.getSumoning()
        }
      })
    },
    scrollLocation () {
      this.$nextTick(() => {
        const scrollTop = getUser('scrollSumoning')
        if (scrollTop) {
          this.$refs.sumoning.scrollTop = scrollTop
          remove('scrollSumoning')
        }
      })
    },
    goDetails () {
      set('scrollSumoning', this.$refs.sumoning.scrollTop)
    },
    goCreate () {
      this.$router.push({
        path: '/exerland/createSummoningOrder'
      })
    },
    getSumoning () {
      const user = getUser('user')
      const { page, size } = this
      const promise = get({
        url: `/call/talesList/${user.id}?page=${page}&size=${size}`
      })
      promise.then(res => {
        const {
          data: {
            code,
            detail: { count, list }
          }
        } = res
        if (Object.is(code, 200)) {
          this.updateTaleCount(0)
          this.count = count
          // 下拉刷新时
          if (this.downRefresh) {
            this.sumoning = list
          } else {
            this.sumoning = [...this.sumoning, ...list]
          }
          this.loading = false
          const { sumoning, page } = this
          if (count > sumoning.length) {
            this.loading = true
            this.page = page + 1
          } else {
            this.finished = true
          }
          this.loading = false
          this.scrollLocation()
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.sumoning {
  background: #fff;
  box-sizing: border-box;
  z-index: 1;
  height: calc(100% - 50px);
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  .analyse_icon{
    width: 50px;
    height: 50px;
    background-color: #fff;
    position: absolute;
    border-radius: 50%;
    top: 85%;
    left: 80%;
    img{
      width: 50px;
      height: 50px;
      border-radius: 50%;
    }
  }
  h3 {
    font-size: 17px;
    font-family: SFProText-Semibold, SFProText;
    font-weight: 600;
    color: rgba(0, 0, 0, 1);
    line-height: 22px;
    text-align: center;
    padding: 13px 4.27vw;
  }
  .content {
    margin-bottom: 1px;
    padding: 0 16px;
    margin-top: 12px;
  }
  .empty {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    height: calc(100% - 50px);
    span {
      width: 176px;
      text-align: center;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(136, 136, 136, 1);
      line-height: 26px;
    }
    button {
      width: 132px;
      height: 44px;
      background: rgba(245, 245, 245, 1);
      border-radius: 4px;
      font-size: 17px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(0, 0, 0, 1);
      line-height: 24px;
      border: none;
      outline: none;
      margin-top: 25px;
    }
  }
}
</style>
